import { render } from "./IconSelector.vue?vue&type=template&id=55b9b66d&scoped=true"
import script from "./IconSelector.vue?vue&type=script&lang=js"
export * from "./IconSelector.vue?vue&type=script&lang=js"

import "./IconSelector.vue?vue&type=style&index=0&id=55b9b66d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b9b66d"]])

export default __exports__